import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BackAndForthWarningComponent } from '../back-and-forth-warning/back-and-forth-warning.component';
import { OnBoardingService } from '../../../services/on-boarding.service';
import { GoogleAnalyticsService } from '../../../../services/googleanalytics.service';
import { GoogleAnalyticsEvents } from '../../../../models/GoogleAnalyticsEvents';
import { catchError, filter } from 'rxjs/operators';
import { of } from 'rxjs';
import { ShiftsService } from 'src/app/services/apis/shifts.service';
import { ManageUsersAccountService } from '../../../../services/manage-users-account.service';

@Component({
  selector: 'app-schedule-creation-state-buttons',
  templateUrl: './schedule-creation-state-buttons.component.html',
  styleUrls: ['./schedule-creation-state-buttons.component.scss']
})
export class ScheduleCreationStateButtonsComponent implements OnInit {

  @Input() savedDate: Date;
  @Input() validSaveBtn: boolean;
  @Input() hideBack: boolean;
  @Input() hideSave: boolean;
  @Input() hideButtons: boolean;
  @Input() hideNext: boolean = false;
  @Input() validNextBtn: boolean;
  @Input() validBackBtn: boolean;
  @Input() changed: boolean;
  @Input() currentState: number;
  @Input() availableSteps: number[];
  @Output() saveButtonClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() forwardStateChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() backwardsStateChange: EventEmitter<number> = new EventEmitter<number>();

  doNotShow = false;

  private _analyticsEvents = new GoogleAnalyticsEvents();

  constructor(
    private _accountService: ManageUsersAccountService,
    private _dialog: MatDialog,
    private _onBoardingService: OnBoardingService,
    private _analyticsService: GoogleAnalyticsService,
    private _shiftJavaService: ShiftsService
  ) { }

  ngOnInit(): void {
    this._accountService.currentUserSubject.pipe(
      filter(e => !!e)
    ).subscribe(() => {
      this._getStoredData();
    });
  }

  back(btn: ElementRef, clickHeight: number) {
    if (!!this.changed && !this.doNotShow) {
      this._dialog.open(BackAndForthWarningComponent, {
        position: {
          top: (clickHeight - 182) + 'px',
          left: (btn.nativeElement.offsetLeft + 306 - 112) + 'px'
        },
        data: {
          doNotShow: this.doNotShow
        },
        panelClass: 'custom-dialog-container',
        width: '426px',
        height: '172px'
      }).afterClosed().subscribe(result => {
        if (result === true) {
          this.doNotShow = result;
        }
      });
    } else {
      this._goBack();
    }
  }

  forward(btn: ElementRef, clickHeight: number) {
    if (!!this.changed && !this.doNotShow) {
      this._dialog.open(BackAndForthWarningComponent, {
        position: {
          top: (clickHeight - 182) + 'px',
          left: (btn.nativeElement.offsetLeft + 150) + 'px'
        },
        data: {
          doNotShow: this.doNotShow
        },
        panelClass: 'custom-dialog-container',
        width: '426px',
        height: '172px'
      }).afterClosed().subscribe(result => {
        if (result === true) {
          this.doNotShow = result;
        }
      });
    } else {
      this.forwardStateChange.emit(this.currentState + 1);
    }
  }

  private _goBack() {
    this._onBoardingService.goBack();
    this._analyticsService.eventEmitter(this._analyticsEvents.onboarding.category,
      this._analyticsEvents.onboarding.action.navigation_back.name,
      this._analyticsEvents.onboarding.action.navigation_back.label
    );
  }

  private _getStoredData() {
    return this._shiftJavaService.getJson('doNotShow').pipe(catchError(err => of({}))).subscribe(resp => {
      this.doNotShow = !!resp;
    });
  }
}
